import { useState } from "react"

import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { FaSync } from "react-icons/fa"

import { AuditPoolReportGenerate } from "../../../api/Reports/WorkforceReport"
import FormatDate from "../../../formatters/FormatDate"
import handleAPIError from "../../../utils/handleAPIError"
import printPdf from "../../../utils/printPdf"
import ActionButton from "../../ActionButton"
import FromToDates from "../../Reports/FromToDates"

interface AuditPoolModalProps {
  poolID: number
  poolName: string
  onClose: () => void
}

const AuditPoolModal = (props: AuditPoolModalProps) => {
  const { onClose, poolID, poolName } = props
  const [generating, setGenerating] = useState(false)
  const [from, setFrom] = useState<Date>()
  const [to, setTo] = useState<Date>()
  const [includeAllDates, setIncludeAllDates] = useState<boolean>(false)

  const handleCancelClick = () => onClose()
  const handleClearClick = () => {
    setFrom(undefined)
    setTo(undefined)
  }

  const getReportParams = () => ({
    DateFrom: FormatDate(from),
    DateTo: FormatDate(to),
    AllDates: includeAllDates,
    PoolID: poolID,
    PoolName: poolName,
  })

  const checkAllDates = (checked: boolean) => {
    setIncludeAllDates(checked)
    setFrom(undefined)
    setTo(undefined)
  }

  const handleGenerateCsvClick = () => {
    setGenerating(true)
    AuditPoolReportGenerate(getReportParams()).subscribe(
      (base64pdf: string) => {
        setGenerating(false)
        printPdf(base64pdf)
      },
      (error) => handleAPIError(error, () => setGenerating(false))
    )
  }

  const isParamsValid = () => includeAllDates || (!!from && !!to)

  return (
    <Modal backdrop="static" centered show onHide={() => handleCancelClick()}>
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase">EXPORT CSV OPTIONS:</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-3">
        <Form>
          <Row>
            <Col sm={4}>
              <Form.Label htmlFor="include_all_dates">Include All Dates</Form.Label>
            </Col>
            <Col>
              <Form.Check
                id="include_all_dates"
                type="checkbox"
                inline
                className="abc-checkbox abc-checkbox-inline"
                label=""
                value={includeAllDates ? 1 : 0}
                checked={includeAllDates}
                onChange={(e) => checkAllDates(e.target.checked)}
              />
            </Col>
          </Row>
          {!includeAllDates && (
            <Row>
              <Col>
                <FromToDates from={from} to={to} onChangeFrom={setFrom} onChangeTo={setTo} />
              </Col>
            </Row>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button variant="secondary" className="mr-auto" onClick={handleClearClick}>
          Clear Filter&nbsp;
          <FaSync />
        </Button>
        <ActionButton
          variant="primary"
          disabled={!isParamsValid()}
          onClick={handleGenerateCsvClick}
          spin={generating}
          disableOnSpin
        >
          Export
        </ActionButton>
      </Modal.Footer>
    </Modal>
  )
}
export default AuditPoolModal
